/**
 * Shared QueryClient instance.
 *
 * Extracted from App.tsx so that non-React modules (e.g. pending-transactions)
 * can invalidate queries without a hook.
 */
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
